export const PREMIUM_HUB_DASHBOARD_URL =
  process.env.REACT_APP_PREMIUM_HUB_URL || "https://dashboard.premiumsender.com";
